import axios, { AxiosInstance } from "axios";
import { Setting } from "../../shared/utils/Settings";
import { DELAY } from "../../shared/utils/Utils";
import EnvObj from "../models/objs/env.obj";


export default class Endpoints {
    constructor(){
        this.axiosInstance = axios.create({
            baseURL: window.location.origin
        });
    }
    private axiosInstance: AxiosInstance;
    static instance: Endpoints = new Endpoints();
    private _ENVIRONMENT: EnvObj = {};
    private _KEYCLOACK: any;

    static getInstance() {
        if (Endpoints.instance == null) {
            Endpoints.instance = new Endpoints();
        }

        return this.instance;
    }

    async getEnvironment(): Promise<EnvObj>{
        if(Setting.LOCAL_MODE === true){
            await DELAY(1000);
            this._ENVIRONMENT = {

                // BACKEND_URL: 'https://stor-beint-stor-svil.apps.ocp.int-consob.svil/',
                // KEYCLOACK_CONFIG: {
                //     "realm": "svilintrealm",
                //     "url": "https://sso-int.int-consob.svil/auth/",
                //     "clientId": "STOR",

                //   },
                // FILENET_URL:'http://172.21.84.71/navigator/bookmark.jsp?desktop=ARCHIVIO&repositoryId=P8&repositoryType=p8&docid=Folder%2C$url&mimeType=folder&template_name=Folder'
                  
                BACKEND_URL: 'https://stor-be-stor-svil.apps.ocp.int-consob.svil/',
                KEYCLOACK_CONFIG: {
                    "realm": "svilextrealm",
                    "url": "https://secure-sso-rhsso-svil.apps.ocp.int-consob.svil/auth/",
                    "clientId": "STOR",
                  },
                FILENET_URL:'http://172.21.84.71/navigator/bookmark.jsp?desktop=ARCHIVIO&repositoryId=P8&repositoryType=p8&docid=Folder%2C$url&mimeType=folder&template_name=Folder'
            
            
            }
            return this._ENVIRONMENT;
        }
        else{
            return await this.axiosInstance.get(
            'stor-fe/config/env.json',
                ).then(response => {
                this._ENVIRONMENT = response.data;
                return response.data;
                }).catch(error => {
                return undefined;
                });
        }
    }

    public setKEYCLOACK(keycloackConfig: any){
        this._KEYCLOACK = keycloackConfig;
    }

    public get KEYCLOACK(): any{
        return this._KEYCLOACK;
    }

    public get ENV_API_PATH(): string {
        if(this._ENVIRONMENT && this._ENVIRONMENT.BACKEND_URL && this._ENVIRONMENT.BACKEND_URL.length > 0){
            return this._ENVIRONMENT.BACKEND_URL;
        }
        return '';
    }

    public get FILENET_PATH(): string {
        if(this._ENVIRONMENT && this._ENVIRONMENT.FILENET_URL && this._ENVIRONMENT.FILENET_URL.length > 0){
            return this._ENVIRONMENT.FILENET_URL;
        }
        return '';
    }
}